/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { a as compressImage$1 } from '../../../index-0bcce539.js';
import '../../../index-892d8eee.js';
import '../../../_commonjsHelpers-56d33373.js';

// https://universal-api.js.org/packages/media/compress-image
function compressImage(options) {
    var success = options.success, fail = options.fail, filePaths = options.filePaths, _a = options.compressLevel, compressLevel = _a === void 0 ? 0 : _a;
    // 压缩质量，范围0～3，1-低，2-中，3-高
    var quality = compressLevel > 0 && compressLevel <= 3 ? compressLevel - 1 : 0;
    compressImage$1({
        src: filePaths === null || filePaths === void 0 ? void 0 : filePaths[0],
        quality: quality,
    })
        .then(function (tempFilePath) { return success({ filePaths: [tempFilePath] }); })
        .catch(fail);
}

export { compressImage as default };
